import { formatterPx, parsePx } from '@/utils';

export default (selectedObjectProps, t) => {
  return {
    fields: [
      ...(selectedObjectProps.$$translatedProps
        ? [
            {
              as: 'button',
              name: 'retranslate',
              text: t('propsEditor.recoveryTranslate'),
              type: 'default',
              size: 'small',
              // icon: 'fluent:calendar-cancel-16-filled',
              // compStyle: { width: '100%' },
            },
          ]
        : []),
      {
        type: 'group',
        label: t('propsEditor.positionInfo'),
        expanded: true,
        labelWidth: '30px',
        children: [
          {
            type: 'inline',
            labelWidth: '30px',
            children: [
              {
                as: 'number',
                label: t('propsEditor.width'),
                placeholder: t('propsEditor.width'),
                name: 'width',
                min: 0,
                formatter: formatterPx,
                parser: parsePx,
                compStyle: { width: '72px' },
                style: { width: '120px' },
              },
              {
                as: 'number',
                label: t('propsEditor.height'),
                placeholder: t('propsEditor.height'),
                name: 'height',
                min: 0,
                formatter: formatterPx,
                parser: parsePx,
                compStyle: { width: '72px' },
                style: { width: '120px' },
              },
            ],
          },
          {
            type: 'inline',
            labelWidth: '30px',
            children: [
              {
                as: 'number',
                label: t('propsEditor.horizontal'),
                placeholder: t('propsEditor.horizontal'),
                name: 'left',
                formatter: formatterPx,
                min: 0,
                parser: parsePx,
                compStyle: { width: '72px' },
                style: { width: '120px' },
              },
              {
                as: 'number',
                label: t('propsEditor.vertical'),
                placeholder: t('propsEditor.vertical'),
                name: 'top',
                min: 0,
                formatter: formatterPx,
                parser: parsePx,
                compStyle: { width: '72px' },
                style: { width: '120px' },
              },
            ],
          },
        ],
      },
    ],
  };
};
